import { AppForm } from '../../../../../../common/forms/app.form';
import { FormControl, Validators } from '@angular/forms';
import { inject, Injectable, signal, Signal, WritableSignal } from '@angular/core';
import {
  GminaAppEntityDictionaryGmina,
  GminaService, ObrebAppEntityDictionaryGmina,
  ObrebAppEntityDictionaryObreb,
  ObrebService, ParcelAppEntityParcelWrite
} from '../../../../../../openapi';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable()
export class ParcelItemForm extends AppForm {

  public gminaList: Signal<GminaAppEntityDictionaryGmina[] | undefined> = toSignal(
    inject(GminaService).getGminaCollectionGminaCollection({
      pagination: false,
      orderName: 'asc'
    })
  );

  public obrebList: WritableSignal<ObrebAppEntityDictionaryGmina[]> = signal([]);

  constructor() {
    super({
      precinct: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      registrationNumber: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      municipality: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      city: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      })
    });
  }

  public municipalityChange(value: string): void {
    const selected = this.gminaList()?.filter(v => v.name === value)?.at(0);
    this.get('precinct')?.setValue('');
    this.obrebList.update(() => selected?.obreby || []);
  }

  public precinctChange(value: any): void {
    const city = this.get('city') as FormControl;
    city.setValue(isNaN(+value) ? value : this.value.municipality);
  }

  public override patchFormValues(value: ParcelAppEntityParcelWrite) {
    this.municipalityChange(value?.municipality || '');
    super.patchFormValues(value);
  }
}
